import { computed } from 'vue';
import store from '@/store';

export default class SelectedCountryCounterComponent {
	public numCheckedCountries = computed((): number => {
		return store.getters.numCheckedCountries();
	});
}
